/** Based on the HeroSection padding. */
export const npPageMtClassName = "mt-8 lg:mt-12 xl:mt-20 scroll-mt-8 lg:scroll-mt-12 xl:scroll-mt-20"
export const npPageGapClassName = "gap-4 lg:gap-6 xl:gap-10"
export const npPageGap2ClassName = "gap-y-8 md:gap-y-12 xl:gap-y-20"
export const npPagePtClassName = "pt-4 lg:pt-6 xl:pt-10"
export const npPagePxClassName = "px-4 lg:px-6 xl:px-10"
export const npPagePbClassName = "pb-4 lg:pb-6 xl:pb-10"

export const npSectionGapClassName = "gap-20 xl:gap-30"
export const npSectionMtClassName = "mt-20 xl:mt-30 scroll-mt-20 xl:scroll-mt-30"
export const npSectionMbClassName = "mb-20 xl:mb-30"

export const npPageWidthClassName = "w-400 max-w-full mx-auto"
